// Imports
import { PortalContext } from 'src/modules/01 Global/jsx/contexts.jsx';

// Stateless components

export function Page404(props) {

    function render404Page(context) {

        var viewport = context['viewport'];
        var is_mobile = false;

        if(viewport < 3) {
            is_mobile = true;
        }

        var configuration = context['configuration'];
        var page_title = "Page not found";
        var page_content = "";

        if (configuration['system_messages'] && configuration['system_messages']['pageNotFound']) {
            page_title = configuration['system_messages']['pageNotFound']['heading'];
            page_content = {
                __html: configuration['system_messages']['pageNotFound']['content']
            };
        }

        return (
            <>
                {is_mobile ? (
                    <>
                        <div className="page-header__wrapper">
                            <div className="inner">
                                <h1 className="page-header__title">{page_title}</h1>
                            </div>
                        </div>
                        <div id="main__content" className="page-inner__wrapper">
                            <div className="page-inner__content" dangerouslySetInnerHTML={page_content}>
                            </div>
                        </div>
                    </>
                ) : (
                    <div id="main__content" className="page-inner__wrapper">
                        <div className="page-inner__header">
                            <h1 className="page-header__title">{page_title}</h1>
                        </div>
                        <div dangerouslySetInnerHTML={page_content}></div>
                    </div>
                )}
            </>
        );
    }

    

    //
    // Render
    //

    return (
        <PortalContext.Consumer>
            {render404Page}
        </PortalContext.Consumer>
    );

};
